import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { setupIntentApi } from '~/Providers/Api';

const useSetupIntent = (bypassAccountCheck = false) => {
  const [setupIntent, setSetupIntent] = useState(null);
  const [error, setError] = useState(null);
  const search = new URLSearchParams(window.location.search);
  const [setupIntentId, setSetupIntentId] = useState(search.get('setup_intent'));
  const accountId = useSelector(({ Account }) => Account.data?.id);
  useEffect(() => {
    if (!accountId && !bypassAccountCheck) return;

    const promise = setupIntentId
      ? setupIntentApi.findById(setupIntentId)
      : setupIntentApi.findOrCreate();
    promise
      .then(response => {
        console.log('useSetupIntent', response);
        setSetupIntent({
          clientSecret: response.data.client_secret,
          ...response.data,
        });
      })
      .catch(error => {
        console.error('useSetupIntent', error);
        setError(error);
      });
  }, [setupIntentId, accountId, bypassAccountCheck]);

  return { setupIntent, error, setSetupIntentId };
};

export default useSetupIntent;
